import { OfferCatalogData } from "../types/schema.types";
import type { OfferCatalog } from "schema-dts";
import { generateOfferCatalog } from "../utils/schema-generators";

/**
 * Builds Schema.org OfferCatalog structured data
 * @param offerCatalogData - Offer catalog information for schema generation
 * @returns Schema.org OfferCatalog object (without @context — injector handles that)
 */
export function buildOfferCatalogSchema(
  offerCatalogData: OfferCatalogData
): OfferCatalog {
  return generateOfferCatalog(
    offerCatalogData.name,
    offerCatalogData.description,
    offerCatalogData.url,
    offerCatalogData.products,
    offerCatalogData.breadcrumbs
  );
}
